import 'css-chunksrc/client/pages/projectPage/kanbanPage/statusCreationForm/switch/styles.scss';export default {
  "switch": "_switch_1kmq6_1",
  "button": "_button_1kmq6_14",
  "paragraph": "_paragraph_1kmq6_20"
};